var map = {
	"./1_polygon_art.png": 6006,
	"./2_pac_man.png": 7424,
	"./3_lilt.png": 6967,
	"./4_easy_pay.png": 3378,
	"./5_misc_games.png": 4076,
	"./6_bezie.png": 1760,
	"./7_mafia_icon.png": 2036,
	"./8_nira.png": 1335,
	"./ShanLogo.png": 5749,
	"./artworks/aandal_art.jpg": 2181,
	"./artworks/brochure_pages.jpg": 4657,
	"./artworks/bull_art.jpg": 1381,
	"./artworks/ctf-logo.png": 3991,
	"./artworks/firstAcrylic.jpg": 1127,
	"./artworks/hungama.jpg": 9601,
	"./artworks/invitation_model_2.jpg": 5720,
	"./artworks/ir-brochure-frontpage.jpg": 4259,
	"./artworks/kidol.jpg": 3671,
	"./artworks/note-cover.png": 8394,
	"./artworks/paradiseLost.jpg": 7857,
	"./artworks/parrot_art.jpg": 6766,
	"./artworks/rajasthan_art.jpg": 1206,
	"./artworks/sparks-logo-new1.jpg": 8691,
	"./artworks/theGorgeousSunset.jpg": 3878,
	"./artworks/theSplashingLighthouse.jpg": 460,
	"./artworks/thumbsup-profile-pic-copy.jpg": 1225,
	"./artworks/windows_ui.jpg": 8640,
	"./bezie/bezie-1.png": 5473,
	"./bezie/bezie-2.png": 9226,
	"./bezie/bezie-3.png": 5411,
	"./bezie/bezie-4.png": 6012,
	"./bsiteLogo.png": 60,
	"./ghosts/screen-1.png": 4919,
	"./ghosts/screen-2.png": 988,
	"./lilt/screen-1.png": 1984,
	"./lilt/screen-2.png": 315,
	"./lilt/screen-3.png": 6098,
	"./lilt/screen-4.png": 8605,
	"./lilt/screen-5.png": 8660,
	"./logo.png": 3153,
	"./mafia/screen-1.webp": 9068,
	"./mafia/screen-2.webp": 5929,
	"./mafia/screen-3.webp": 1422,
	"./mafia/screen-4.webp": 7779,
	"./mafia/screen-5.webp": 7728,
	"./misc_games/screen-1.png": 5543,
	"./myPic3.webp": 2182,
	"./nira/nira_screen.png": 7402,
	"./nira/nira_screen_2.png": 8213,
	"./nira/nira_screen_3.png": 9116,
	"./polygonart/screen-1.webp": 5565,
	"./polygonart/screen-2.webp": 8832,
	"./polygonart/screen-3.webp": 6323,
	"./polygonart/screen-4.webp": 734,
	"./polygonart/screen-5.webp": 4006,
	"./polygonart/screen-6.webp": 6348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1579;